import React from 'react'
//context
import { useContext, useEffect, useState } from 'react'
//player context
import { CharacterContext } from '../../../contexts/character'

//custom select
import Select from 'react-select'

//Job Ids
import * as jobID from '../../../data/jobID'

function JobLevelSelect(props) {
	const { job, changeJobLevel, jobLevel } = useContext(CharacterContext)

	const [maxJobLevel, setMaxJobLevel] = useState(Number(10))
	const [options, setOptions] = useState([])
	const [selectedValue, setSelectedValue] = useState([
		{
			value: 1,
			label: 1,
			key: 'jlv' + 1,
		},
	])

	useEffect(() => {
		if (job === jobID.NOVICE || job === jobID.NOVICE_HIGH)
			setMaxJobLevel(10)
		else setMaxJobLevel(50)

		if (
			job & jobID.EAJL_THIRD ||
			(job & jobID.EAJL_UPPER && job & jobID.EAJL_2)
		)
			setMaxJobLevel(70)

		if (
			job === jobID.SOUL_REAPER ||
			job === jobID.STAR_EMPEROR ||
			job === jobID.KAGEROU ||
			job === jobID.OBORO ||
			job === jobID.REBELLION
		)
			setMaxJobLevel(65)
	}, [job])

	useEffect(() => {
		let newOptions = []
		if (job === jobID.SUMMONER) setMaxJobLevel(50)
		for (let i = 1; i <= maxJobLevel; i++) {
			newOptions.push({
				value: i,
				label: i,
				key: 'jlv' + i,
				// isFixed: true,
			})
		}
		setOptions(newOptions)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [maxJobLevel])

	useEffect(() => {
		if (jobLevel > maxJobLevel) {
			changeJobLevel(maxJobLevel)
			let newopt = options.find((opt) => opt.value === jobLevel)
			if (newopt) setSelectedValue(newopt)
			else {
				console.log('job level not found')
				setSelectedValue([
					{
						value: Number(maxJobLevel),
						label: Number(maxJobLevel),
						key: props.id + Number(maxJobLevel),
					},
				])
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [options])

	useEffect(() => {
		if (options.length > 0) {
			let newopt = options.find((opt) => opt.value === jobLevel)
			if (newopt) setSelectedValue(newopt)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jobLevel, options])

	return (
		<div>
			<Select
				styles={props.customStyles}
				value={selectedValue}
				id={props.id}
				className={props.className}
				onChange={(event) => {
					changeJobLevel(Number(event.value))
					setSelectedValue([
						{
							value: Number(event.value),
							label: Number(event.value),
							key: 'jlv' + Number(event.value),
							// isFixed: true,
						},
					])
				}}
				options={options}
			/>
		</div>
	)
}

export default JobLevelSelect
